import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

const StudentDuplicateModal = ({ show, duplicateInfo, onConfirm, onClose }) => {
  const { t: tr } = useTranslation();
  if (!show || !duplicateInfo) return null;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton closeLabel={tr("common:close")}>
        <Modal.Title>{tr("manage:warningDuplicateStudent_349")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{tr("manage:student_14")} <strong>{duplicateInfo.firstName} {duplicateInfo.lastName || ''}</strong> {tr("manage:alreadyExistsAndIsLinkedToClient_350")} <strong>{duplicateInfo.clientName || duplicateInfo.clientId}</strong>.
        </p>
        <p className="mb-0">{tr("manage:areYouSureYouWantToSave_351")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>{tr("common:cancel")}</Button>
        <Button variant="primary" onClick={onConfirm}>{tr("manage:yesSaveAnyway_107")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

StudentDuplicateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  duplicateInfo: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    clientName: PropTypes.string,
    clientId: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

StudentDuplicateModal.defaultProps = {
  duplicateInfo: null,
};

export default StudentDuplicateModal;
